import { render } from "./HepaticsTableView.vue?vue&type=template&id=46dd8e37"
import script from "./HepaticsTableView.vue?vue&type=script&lang=js"
export * from "./HepaticsTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__